import { LogoIcon } from "./Icons";
import { Button } from "./ui/button";

export const Footer = () => {
  const goToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <footer id="footer">
      <hr className="w-11/12 mx-auto" />

      <section className="container flex flex-col items-center py-5">
        <div className="flex flex-row items-center gap-2">
          <Button
            onClick={goToTop}
            className="bg-transparent shadow-none hover:bg-transparent text-white"
          >
            <LogoIcon />
            Doyen Trading
          </Button>
        </div>
        
        {/* Social Links */}
        <div className="flex flex-row items-center mt-4">
          <a 
            href="https://discord.gg/ZCg7PMpsSe" 
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
          >
            <img src="/Discord-Symbol-White.png" alt="Join our Discord" style={{ verticalAlign: "middle" }} width={20} height={20}/>
          </a>
          <a 
            href="https://x.com/1130lab"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center ml-4 text-muted-foreground hover:text-primary transition-colors"
          >
            <img src="/X-Logo-White.png" alt="Follow us on X" style={{ verticalAlign: "middle" }} width={16} height={16}/>
          </a>
          <a 
            href="https://www.youtube.com/@DoyenTrading"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center ml-4 text-muted-foreground hover:text-primary transition-colors"
          >
            <img src="/yt_icon_red_digital_nows.png" alt="Follow us on YouTube" style={{ verticalAlign: "middle" }} width={24} height={24}/>
          </a>
          <a 
            href="https://www.tiktok.com/@1130lab"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center ml-3 text-muted-foreground hover:text-primary transition-colors"
          >
            <img src="/TikTok_Icon_Black_Circle.png" alt="Follow us on TikTok" style={{ verticalAlign: "middle" }} width={24} height={24}/>
          </a>
        </div>

        <div className="flex flex-row items-center gap-4 mt-4">
        <a href="/terms" className="text-muted-foreground hover:text-primary transition-colors">
          Terms of Service
        </a>
        <a href="/privacy" className="text-muted-foreground hover:text-primary transition-colors">Privacy Policy</a>
        </div>
        <text className="mt-2">
          Page template by{" "}
          <a
            rel="noreferrer noopener"
            target="_blank"
            href="https://www.linkedin.com/in/leopoldo-miranda/"
            className="text-primary transition-all border-primary hover:border-b-2"
          >
            Leo Miranda
          </a>
        </text>
      </section>
      <section className="container pb-14 text-center">
      </section>

      <section className="container pb-14 text-center">
        <text>
          &copy; 2026 <a rel="noreferrer noopener" target="_blank" href="https://www.1130lab.com/" className="text-primary transition-all border-primary hover:border-b-2">1130 Lab.</a> All rights reserved.
        </text>
      </section>
    </footer>
  );
};
